// Listas para el formulario de inscripción internacional

export const COUNTRIES = [
  // América Latina
  'Argentina','Bolivia','Brasil','Chile','Colombia','Costa Rica','Cuba','Ecuador',
  'El Salvador','Guatemala','Haití','Honduras','México','Nicaragua','Panamá','Paraguay',
  'Perú','Puerto Rico','República Dominicana','Uruguay','Venezuela',
  // Norteamérica
  'Estados Unidos','Canadá',
  // Europa
  'España','Portugal','Francia','Italia','Alemania','Reino Unido','Irlanda','Países Bajos',
  'Bélgica','Suiza','Austria','Suecia','Noruega','Dinamarca','Finlandia','Polonia',
  'República Checa','Rumania','Grecia','Turquía','Rusia','Ucrania',
  // Asia
  'China','Japón','Corea del Sur','India','Indonesia','Filipinas','Singapur','Malasia',
  'Tailandia','Vietnam','Israel','Arabia Saudita','Emiratos Árabes Unidos',
  // África
  'Egipto','Marruecos','Sudáfrica','Nigeria','Kenia',
  // Oceanía
  'Australia','Nueva Zelanda',
  // Otros
  'Otro',
];

export const JOB_TITLES = [
  // Ejecutivo / Dirección
  'Director(a) Ejecutivo / CEO',
  'Director(a) General',
  'Director(a) de Operaciones / COO',
  'Director(a) de Tecnología / CTO',
  'Director(a) Financiero / CFO',
  'Director(a) de Recursos Humanos / CHRO',
  'Gerente General',
  'Gerente de Proyectos',
  'Gerente de Producto',
  'Gerente de Marketing',
  'Gerente de Ventas',
  'Gerente de Operaciones',
  // Profesionales / Técnicos
  'Consultor(a)',
  'Coordinador(a)',
  'Analista',
  'Especialista',
  'Asesor(a)',
  'Ingeniero(a)',
  'Arquitecto(a)',
  'Auditor(a)',
  'Contador(a)',
  'Abogado(a)',
  'Médico / Profesional de Salud',
  'Investigador(a)',
  'Científico(a) de Datos',
  'Desarrollador(a) de Software',
  'Diseñador(a)',
  // Educación
  'Profesor(a) / Docente',
  'Investigador(a) Académico',
  'Estudiante de Pregrado',
  'Estudiante de Postgrado',
  // Sector Público
  'Funcionario(a) Público',
  'Servidor(a) Público',
  // Otros
  'Empresario(a) / Emprendedor(a)',
  'Freelance / Independiente',
  'Sin empleo actualmente',
  'Otro',
];

export const INDUSTRIES = [
  'Tecnología / Software',
  'Educación',
  'Salud / Medicina',
  'Finanzas / Banca',
  'Gobierno / Sector Público',
  'Consultoría',
  'Manufactura / Industria',
  'Retail / Comercio',
  'Construcción / Inmobiliario',
  'Energía / Petróleo / Minería',
  'Telecomunicaciones',
  'Marketing / Publicidad',
  'Medios / Comunicaciones',
  'Turismo / Hospitalidad',
  'Transporte / Logística',
  'Agricultura / Agroindustria',
  'Legal / Servicios Jurídicos',
  'Recursos Humanos',
  'Investigación / Desarrollo',
  'ONG / Sin Fines de Lucro',
  'Arte / Cultura / Entretenimiento',
  'Otro',
];

export const EDUCATION_LEVELS = [
  'Secundaria',
  'Técnico / Tecnólogo',
  'Pregrado / Bachillerato Universitario',
  'Licenciatura',
  'Especialización / Diplomado',
  'Maestría',
  'Doctorado / PhD',
  'Postdoctorado',
  'Otro',
];

export const EXPERIENCE_YEARS = [
  'Menos de 1 año',
  '1-3 años',
  '4-7 años',
  '8-15 años',
  'Más de 15 años',
];

export const GENDERS = [
  'Femenino',
  'Masculino',
  'No binario',
  'Prefiero no decir',
];

export const LANGUAGES = [
  'Español',
  'Inglés',
  'Portugués',
  'Francés',
  'Italiano',
  'Alemán',
  'Otro',
];

export const REFERRAL_SOURCES = [
  'Búsqueda en Google',
  'Redes sociales (LinkedIn, Facebook, Instagram, X/Twitter)',
  'Recomendación de un amigo o colega',
  'Email / Newsletter',
  'Página web de IAASP',
  'Webinar o evento',
  'Mi empresa / institución',
  'Publicidad pagada',
  'Otro',
];

export const PAYMENT_LABELS = {
  paypal: 'PayPal',
  sinpe: 'SINPE Móvil (Costa Rica)',
  nequi: 'Nequi (Colombia)',
  daviplata: 'Daviplata (Colombia)',
  mercadopago: 'Mercado Pago',
  yappy: 'Yappy (Panamá)',
  bank_transfer: 'Transferencia Bancaria',
  offline: 'Pago Offline (efectivo / oficina)',
  other: 'Otro método',
};
